// extracted by mini-css-extract-plugin
export default {"ripple":"RippleLoader_ripple__jZLUB"};